<template>
  <div>
    <v-text-field
      dense
      v-if="indice == 1"
      type="text"
      v-model="referenciaIPS"
      label="Referencia IPS"
      outlined
      clearable
      required
      @input="busquedaHistorialEnvios(1)"
    ></v-text-field>
    <div v-if="indice == 2">
      <v-text-field
        clearable
        type="text"
        dense
        v-model="remitenteBusqueda"
        label="Remitente"
        outlined
        required
        @input="busquedaHistorialEnvios(2)"
      ></v-text-field>
    </div>
    <div v-if="indice == 3">
      <v-text-field
        clearable
        dense
        type="text"
        v-model="destinatarioBusqueda"
        label="Destinatario"
        outlined
        required
        @input="busquedaHistorialEnvios(3)"
      ></v-text-field>
    </div>
    <v-select
      dense
      v-if="indice == 4"
      v-model="tipoServicio"
      item-text="texto"
      item-value="valor"
      :items="[
        { texto: 'Mensajeria', valor: '1' },
        { texto: 'Paqueteria', valor: '2' },
        { texto: 'Todos', valor: '' }
      ]"
      @input="busquedaHistorialEnvios(4)"
      label="Tipo de Servicio"
      outlined
    ></v-select>
    <v-select
      dense
      v-if="indice == 5"
      v-model="detalleEnvio"
      item-text="texto"
      item-value="valor"
      :items="[
        { texto: 'Internacional Priority', valor: '1' },
        { texto: 'Internacional Economy', valor: '2' },
        { texto: 'Nacional Dia siguiente', valor: '3' },
        { texto: 'Nacional Terrestre', valor: '4' },
        { texto: 'Nacional Regional', valor: '5' },
        { texto: 'Todos', valor: '' }
      ]"
      @input="busquedaHistorialEnvios(5)"
      label="Detalle envio"
      outlined
    ></v-select>
    <v-select
      dense
      v-if="indice == 6"
      v-model="estado"
      item-text="texto"
      item-value="valor"
      :items="[
        { texto: 'Pagado', valor: '1' },
        { texto: 'No pagado', valor: '0' },
        { texto: 'Cancelado', valor: '2' },
        { texto: 'Todos', valor: '' }
      ]"
      @input="busquedaHistorialEnvios(6)"
      label="Estado envio"
      outlined
    ></v-select>
    <v-select
      dense
      clearable
      v-if="indice == 7"
      v-model="sucursalFiltro"
      :items="sucursalesList"
      item-text="NOMBRE"
      item-value="ID"
      @input="busquedaHistorialEnvios(7)"
      label="Sucursal"
      outlined
    ></v-select>
    <v-select
      dense
      clearable
      v-if="indice == 8"
      v-model="usuarioEnvio"
      :items="usuariosNombresApellidos"
      item-text="nombre"
      item-value="id"
      @input="busquedaHistorialEnvios(8)"
      label="Usuario"
      outlined
    ></v-select>

    <v-select
      dense
      
      v-if="indice == 9"
      v-model="cuenta"
      :items="cuentasList"
      item-text="CUENTA"
      item-value="ID"
      @input="busquedaHistorialEnvios(9)"
      label="Cuenta utilizada"
      outlined
    ></v-select>
    <v-text-field
      dense
      v-if="indice == 10"
      type="text"
      clearable
      v-model="guia_fedex"
      label="Guia FEDEX"
      outlined
      required
      @input="busquedaHistorialEnvios(10)"
    ></v-text-field>
    <v-menu
      v-if="indice == 11"
      v-model="menuRangoFechas"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          dense
          clearable
          v-model="rangoDeFechas"
          label="Elija un rango de fechas"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          @input="busquedaHistorialEnvios(11)"
          outlined
        ></v-text-field>
      </template>
      <v-date-picker
        range
        v-model="rangoDeFechas"
        @input="
          checarSiHayQueCerrarRango();
          busquedaHistorialEnvios(11);
        "
      ></v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  props: {
    indice: { type: Number, default: 0 },
    cuentaPasada: { type: String },
    referenciaPasada: { type: String },
    remitentePasada: { type: String },
    destinatarioPasado: { type: String },
    tipoServicioPasado: { type: String, default: "" },
    detalleEnvioPasado: { type: String },
    estadoPasado: { type: String, default: "" },
    sucursalFiltroPasada: { type: String, default: "" },
    usuarioEnvioPasada: { type: String, default: "" },
    guia_fedexPasada: { type: String, default: "" }
  },
  data: () => ({
    menuRangoFechas: false,
    rangoDeFechas: [],
    guia_fedex: "",
    cuenta: "",
    usuarioEnvio: "",
    sucursalFiltro: "",
    referenciaIPS: "",
    remitenteBusqueda: "nose",
    destinatarioBusqueda: "nose",
    tipoServicio: "",
    detalleEnvio: "",
    estado: ""
  }),
  beforeDestroy() {},
  async created() {
    await this.getSucursales();
    await this.getUsuarios();
    await this.getCuentas();
    this.cuenta = this.cuentaPasada;
    this.referenciaIPS = this.referenciaPasada;
    this.remitenteBusqueda = this.remitentePasada;
    this.tipoServicio = this.tipoServicioPasado;
    this.detalleEnvio = this.detalleEnvioPasado;
    this.destinatarioBusqueda = this.destinatarioPasado;
    this.estado = this.estadoPasado;

    this.sucursalFiltro = this.sucursalFiltroPasada;
    this.usuarioEnvio = this.usuarioEnvioPasada;
    this.guia_fedex = this.guia_fedexPasada;
  },
  computed: {
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    ...mapState("usuarios", {
      usuariosL: state => state.listUsuarios
    }),
    rangoFechaInicial() {
      return this.rangoDeFechas[0] ? moment(this.rangoDeFechas[0]).format("L") : "";
    },
    rangoFechaFinal() {
      return this.rangoDeFechas[1] ? moment(this.rangoDeFechas[1]).format("L") : "";
    },
    ...mapState("cuentas", {
      cuentasList: state => state.cuentas
    }),
    usuariosNombresApellidos() {
      let chale = [];
      for (var i = 0; i < this.usuariosL.length; i++) {
        chale.push({nombre:
          this.usuariosL[i].NOMBRE +
            " " +
            this.usuariosL[i].APELLIDO_P +
            " " +
            this.usuariosL[i].APELLIDO_M
        ,id:this.usuariosL[i].ID});
      }
      return chale;
    }
  },
  methods: {
    ...mapActions("sucursales", ["getSucursales"]),
    ...mapActions("usuarios", ["getUsuarios"]),
    ...mapActions("cuentas", ["getCuentas"]),
    busquedaHistorialEnvios(indiceBusqueda) {
      switch (indiceBusqueda) {
        //referencia ips
        case 1:
          this.$emit("buscarFiltro", [1, this.referenciaIPS == null ? "" : this.referenciaIPS]);
          break;
        case 2:
          this.$emit("buscarFiltro", [
            2,
            this.remitenteBusqueda == null ? "" : this.remitenteBusqueda
          ]);
          break;
        case 3:
          this.$emit("buscarFiltro", [
            3,
            this.destinatarioBusqueda == null ? "" : this.destinatarioBusqueda
          ]);
          break;
        case 4:
          this.$emit("buscarFiltro", [4, this.tipoServicio == null ? "" : this.tipoServicio]);
          break;
        case 5:
          this.$emit("buscarFiltro", [5, this.detalleEnvio == null ? "" : this.detalleEnvio]);
          break;
        case 6:
          this.$emit("buscarFiltro", [6, this.estado == null ? "" : this.estado]);
          break;
        case 7:
          this.$emit("buscarFiltro", [7, this.sucursalFiltro == null ? "" : this.sucursalFiltro]);
          break;
        case 8:
          this.$emit("buscarFiltro", [8, this.usuarioEnvio == null ? "" : this.usuarioEnvio]);
          break;
        case 9:
          this.$emit("buscarFiltro", [9, this.cuenta == null ? "" : this.cuenta]);
          break;
        case 10:
          this.$emit("buscarFiltro", [10, this.guia_fedex == null ? "" : this.guia_fedex]);
          break;
        case 11:
          if (this.rangoDeFechas == null) {
            this.rangoDeFechas = [];
          }
          try {
            this.$emit("buscarFiltro", [11, this.rangoFechaInicial, this.rangoFechaFinal]);
          } catch (e) {}
          break;
        default:
          break;
      }

      // this.$emit("buscarFiltro", {
      //   pag: this.pagina,
      //   regPag: this.regPag,
      //   referencia: this.referenciaIPS,
      //   remitente: this.remitenteBusqueda,
      //   destinatario: this.destinatarioBusqueda,
      //   fecha_inicio: this.rangoFechaInicial,
      //   fecha_fin: this.rangoFechaFinal,
      //   tipoServicio: this.tipoServicio,
      //   detalleEnvio: this.detalleEnvio,
      //   estado: this.estado,
      //   usuarioEnvio: this.usuarioEnvio,
      //   cuenta: this.cuenta,
      //   guia_fedex: this.guia_fedex,
      //   sucursal: this.sucursalFiltro
      // });
    },
    checarSiHayQueCerrarRango() {
      if (this.rangoDeFechas[1]) {
        this.menuRangoFechas = false;
        this.busquedaHistorialEnvios();
      }
    }
  }
};
</script>
